export default function Contacts() {
    return (
        "Contacts"
    )
}
